export default __webpack_public_path__ + "static/Toyota-75dbd1545b580422b36ddfa48b21a0c5.png";